import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElIcons from '@element-plus/icons-vue'
import locale from 'element-plus/lib/locale/lang/zh-cn'//引入中文版
import DataVVue3 from '@kjgl77/datav-vue3'

// dayjs 插件注册：el-date-picker 周选择器的周数格式（WW/ww 等 token）依赖这些插件，
// 否则报 "isoWeek is not a function"（dayjs 与 element-plus 共用同一实例，extend 全局生效）
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import 'dayjs/locale/zh-cn'
dayjs.extend(isoWeek)
dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
dayjs.locale('zh-cn')
	
const app = createApp(App)
for (const name in ElIcons){
	app.component(name,(ElIcons as any)[name])
}

app.use(store).use(router).use(DataVVue3).use(ElementPlus,{locale}).mount('#app')
